import { lloFetch } from '../../helpers/lloFetch';
import trans from '../../helpers/trans';
import { FetchResult, FetchResultType } from '../FetchResult';
import { SchoolExperience, SchoolExperienceRequest } from './SchoolExperience';
import { transformToSchoolExperience } from './SchoolExperienceTransformers';

export const postSchoolExperienceApiCall = async (schoolExperienceRequest: SchoolExperienceRequest, candidateUuid: string): Promise<FetchResult<SchoolExperience, string>> => {
    try {
        const response = await lloFetch(`/api/learningExperience/${candidateUuid}`, {
            method: 'POST',
            candidateUuid,
            body: JSON.stringify(schoolExperienceRequest),
        });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const schoolExperienceResponse = await response.json();
        const transformedSchoolExperience = transformToSchoolExperience(schoolExperienceResponse);

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformedSchoolExperience,
        };
    } catch (error) {
        console.error('[postSchoolExperienceApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};

export const patchSchoolExperienceApiCall = async (schoolExperienceRequest: SchoolExperienceRequest, candidateUuid: string): Promise<FetchResult<SchoolExperience, string>> => {
    try {
        const response = await lloFetch('/api/learningExperience', {
            method: 'PATCH',
            candidateUuid,
            body: JSON.stringify(schoolExperienceRequest),
        });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const schoolExperienceResponse = await response.json();
        const transformedSchoolExperience = transformToSchoolExperience(schoolExperienceResponse);

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformedSchoolExperience,
        };
    } catch (error) {
        console.error('[patchSchoolExperienceApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};

export const deleteSchoolExperienceApiCall = async (schoolExperienceId: string, candidateUuid: string): Promise<FetchResult<undefined, string>> => {
    try {
        const response = await lloFetch(`/api/learningExperience/${schoolExperienceId}`, {
            method: 'DELETE',
            candidateUuid,
        });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: undefined,
        };
    } catch (error) {
        console.error('[deleteSchoolExperienceApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
